"use strict";

var _slicedToArray = require("/home/travis/build/streamr-dev/landing-page/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/home/travis/build/streamr-dev/landing-page/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/streamr-dev/landing-page/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/home/travis/build/streamr-dev/landing-page/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/home/travis/build/streamr-dev/landing-page/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/streamr-dev/landing-page/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ControlMessage_1 = __importDefault(require("../ControlMessage"));

var MessageRef_1 = __importDefault(require("../../message_layer/MessageRef"));

var ResendFromRequest_1 = __importDefault(require("./ResendFromRequest"));

var Serializer_1 = require("../../../Serializer");

var VERSION = 2;

var ResendFromRequestSerializerV2 = /*#__PURE__*/function (_Serializer_1$Seriali) {
  _inherits(ResendFromRequestSerializerV2, _Serializer_1$Seriali);

  var _super = _createSuper(ResendFromRequestSerializerV2);

  function ResendFromRequestSerializerV2() {
    _classCallCheck(this, ResendFromRequestSerializerV2);

    return _super.apply(this, arguments);
  }

  _createClass(ResendFromRequestSerializerV2, [{
    key: "toArray",
    value: function toArray(resendFromRequest) {
      return [VERSION, ControlMessage_1.default.TYPES.ResendFromRequest, resendFromRequest.requestId, resendFromRequest.streamId, resendFromRequest.streamPartition, resendFromRequest.fromMsgRef.toArray(), resendFromRequest.publisherId, resendFromRequest.sessionToken];
    }
  }, {
    key: "fromArray",
    value: function fromArray(arr) {
      var _arr = _slicedToArray(arr, 8),
          version = _arr[0],
          type = _arr[1],
          // eslint-disable-line @typescript-eslint/no-unused-vars
      requestId = _arr[2],
          streamId = _arr[3],
          streamPartition = _arr[4],
          fromMsgRefArray = _arr[5],
          publisherId = _arr[6],
          sessionToken = _arr[7];

      var _fromMsgRefArray = _slicedToArray(fromMsgRefArray, 2),
          fromTimestamp = _fromMsgRefArray[0],
          fromSequenceNumber = _fromMsgRefArray[1];

      return new ResendFromRequest_1.default({
        version: version,
        requestId: requestId,
        streamId: streamId,
        streamPartition: streamPartition,
        fromMsgRef: new MessageRef_1.default(fromTimestamp, fromSequenceNumber),
        publisherId: publisherId,
        sessionToken: sessionToken
      });
    }
  }]);

  return ResendFromRequestSerializerV2;
}(Serializer_1.Serializer);

exports.default = ResendFromRequestSerializerV2;
ControlMessage_1.default.registerSerializer(VERSION, ControlMessage_1.default.TYPES.ResendFromRequest, new ResendFromRequestSerializerV2());